import React from 'react'
import IconSad from '../svg/icon-sad'
import { t } from 'i18next'

import './modal.css'

const Error = () => {
  return (
    <div className="modal-container">
      <div className="modal-inner text-center">
        <IconSad />
        <div className="modal-content">
          <p>{t('error.default.message')}</p>
          <p>{t('error.default.later')}</p>
        </div>
      </div>
    </div>
  )
}

export default Error



// WEBPACK FOOTER //
// ./src/components/Error.js